import { Modal, Typography } from 'antd';
import { forwardRef, useCallback, useImperativeHandle, useRef } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { roles } from '../../model/types';

interface Props {
    onCancel?: () => void;
    onOk?: (role: roles) => void;
}

interface RoleChangeWarningModalRef {
    open: (roleToChange: roles) => void;
    close: () => void;
}

const styles = {
    warningText: { display: 'block', marginBottom: '1ch' }
};

// TODO: role-update, should decide better/descriptive warning text/content to show user
const RoleChangeWarningModal = forwardRef<RoleChangeWarningModalRef, Props>(({ onCancel, onOk }, ref) => {
    const { t } = useTranslation('people');
    // const [isModalVisible, setIsModalVisible] = useState(false);
    const roleToChangeRef = useRef<roles>(null);
    const [modal, contextHolder] = Modal.useModal();

    const confirm = useCallback(() => {
        modal.confirm({
            centered: true,
            title: t('message.updateRole.title'),
            content: (
                <Trans
                    ns="people"
                    i18nKey="message.updateRole.warningText"
                    components={[
                        <Typography.Text key={0} style={styles.warningText} />,
                        <Typography.Text key={1} style={styles.warningText} />,
                        <Typography.Text key={2} style={styles.warningText} />
                    ]}
                    values={{
                        role: t(`roles.${roleToChangeRef.current}`)
                    }}
                />
            ),
            width: '50%',
            onOk: () => {
                onOk?.(roleToChangeRef.current);
            },
            onCancel: () => {
                onCancel?.();
            }
        });
    }, [modal, onCancel, onOk, t]);
    useImperativeHandle(
        ref,
        () => ({
            open(role) {
                roleToChangeRef.current = role;
                confirm();
            },
            close() {
                // roleToChangeRef.current = null;
            }
        }),
        [confirm]
    );

    return contextHolder;
});

export default RoleChangeWarningModal;

export { type RoleChangeWarningModalRef };
